<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <ContentArea no-padding="true" delta-height="80">
      <v-tabs v-model="active" slider-color="#455A64" class="tabs">
        <v-tab v-if="showGlobalConfiguration" @click="loadGlobalConfiguration">{{ $t('pages.configuration.tabs.global.tabName') }}</v-tab>
        <v-tab-item v-if="showGlobalConfiguration">
          <Panel min-height="300">
            {{ $t('pages.configuration.tabs.global.intro') }}
          </Panel>
        </v-tab-item>

        <v-tab v-if="showMailConfiguration" @click="loadMailConfiguration">{{ $t('pages.configuration.tabs.mail.tabName') }}</v-tab>
        <v-tab-item v-if="showMailConfiguration">
          <ButtonBar>
            <v-btn @click="saveMailConfiguration" class="bw-3">{{ $t('button.save') }}</v-btn>
          </ButtonBar>
          <Panel :title="$t('pages.configuration.tabs.mail.server.header')">
            <PanelColumn>
              <v-flex xs12 sm4 lg2 style="height: 35px;">
                <v-label>{{ $t('pages.configuration.tabs.mail.server.hostName') }}</v-label>
              </v-flex>
              <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                <TextField v-model="mailConfiguration.host" max-width="300"/>
              </v-flex>

              <v-flex xs12 sm4 lg2 style="height: 35px;">
                <v-label>{{ $t('pages.configuration.tabs.mail.server.port') }}</v-label>
              </v-flex>
              <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                <TextField v-model="mailConfiguration.port" max-width="80"/>
              </v-flex>

              <v-flex xs12 sm4 lg2 style="height: 35px;">
                <v-label>{{ $t('pages.configuration.tabs.mail.server.userName') }}</v-label>
              </v-flex>
              <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                <TextField v-model="mailConfiguration.user" max-width="250"/>
              </v-flex>

              <v-flex xs12 sm4 lg2 style="height: 35px;">
                <v-label>{{ $t('pages.configuration.tabs.mail.server.password') }}</v-label>
              </v-flex>
              <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                <TextField v-model="mailConfiguration.password" type="password" max-width="250"/>
              </v-flex>
            </PanelColumn>
          </Panel>

          <Panel :title="$t('pages.configuration.tabs.mail.sender.header')" no-margin-top="true">
            <PanelColumn>
              <v-flex xs12 sm4 lg2 style="height: 35px;">
                <v-label>{{ $t('pages.configuration.tabs.mail.sender.name') }}</v-label>
              </v-flex>
              <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                <TextField v-model="mailConfiguration.fromName" max-width="300"/>
              </v-flex>

              <v-flex xs12 sm4 lg2 style="height: 35px;">
                <v-label>{{ $t('pages.configuration.tabs.mail.sender.email') }}</v-label>
              </v-flex>
              <v-flex xs12 sm8 lg10 style="line-height: 26px; height: 35px;">
                <TextField v-model="mailConfiguration.fromAddress" max-width="300"/>
              </v-flex>
            </PanelColumn>
          </Panel>
        </v-tab-item>

        <v-tab v-if="showMailTemplate" @click="loadMailTemplate">{{ $t('pages.configuration.tabs.mailTemplate.tabName') }}</v-tab>
        <v-tab-item v-if="showMailTemplate">
          <ButtonBar>
            <v-btn @click="showSource = !showSource" class="bw-4">{{ showSource ? $t('button.showFormatted') : $t('button.showSource') }}</v-btn>
            <v-btn @click="saveMailTemplate">{{ this.$t('button.save') }}</v-btn>
          </ButtonBar>
          <Panel>
            <v-container fluid pa-1>
              <v-layout wrap>
                <v-flex xs12 md2 py-1 style="height: 35px;">
                  <v-label>{{ $t('pages.configuration.tabs.mailTemplate.template') }}</v-label>
                </v-flex>
                <v-flex xs12 md4 style="line-height: 26px; height: 35px;">
                  <v-select outlined :items="mailTemplates" v-model="currentTemplateKey" item-text="label" item-value="key" v-on:change="loadMailTemplate"/>
                </v-flex>
                <v-flex md6></v-flex>
                <v-flex xs12 md2 py-1 v-if="currentTemplate" style="height: 35px;">
                  <v-label>{{ $t('pages.configuration.tabs.mailTemplate.subject') }}</v-label>
                </v-flex>
                <v-flex xs12 md10 v-if="currentTemplate" style="line-height: 26px; height: 35px;">
                  <TextField v-model="currentTemplate.values.subject"/>
                </v-flex>
                <v-flex xs12 pt-1 v-if="currentTemplate" style="padding-bottom: 0;">
                  <v-label>Message</v-label>
                </v-flex>
                <v-flex xs12 v-if="currentTemplate">
                  <wysiwyg v-model="currentTemplate.values.body" v-if="!showSource"/>
                  <TextAreaField solo v-model="currentTemplate.values.body" rows="15" v-if="showSource"/>
                </v-flex>
              </v-layout>
            </v-container>
          </Panel>
        </v-tab-item>
      </v-tabs>
    </ContentArea>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import ContentArea from '../components/ContentArea'
import Content from '../components/Content'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import ButtonBar from '../components/ButtonBar'
import TextField from '../components/TextField'
import TextAreaField from '../components/TextAreaField'
import axios from 'axios'
import querystring from 'querystring'

export default {
  name: 'Configuration',
  components: { Header, Sidebar, Footer, ContentArea, Content, Panel, PanelColumn, ButtonBar, TextField, TextAreaField },
  data () {
    return {
      active: null,
      mailConfiguration: {
        host: '',
        port: '',
        user: '',
        password: '',
        fromName: '',
        fromAddress: ''
      },
      currentTemplateKey: 'MAIL_WELCOME',
      currentTemplate: null,
      showSource: false
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'configuration' })
    if (this.isSuperAdmin) {
      this.loadGlobalConfiguration()
    } else {
      this.loadMailConfiguration()
    }
  },
  computed: {
    mailTemplates: function () {
      return [
        {
          key: 'MAIL_WELCOME',
          label: this.$t('pages.configuration.tabs.mailTemplate.templates.welcome'),
          values: {
            subject: '',
            body: ''
          },
          keys: {
            subject: 'TemplateMailWelcomeSubject',
            body: 'TemplateMailWelcomeBody'
          }
        },
        {
          key: 'MAIL_RESET_PASSWORD',
          label: this.$t('pages.configuration.tabs.mailTemplate.templates.resetPassword'),
          values: {
            subject: '',
            body: ''
          },
          keys: {
            subject: 'TemplateMailResetPasswordSubject',
            body: 'TemplateMailResetPasswordBody'
          }
        },
        {
          key: 'MAIL_FORGOT_PASSWORD',
          label: this.$t('pages.configuration.tabs.mailTemplate.templates.forgotPassword'),
          values: {
            subject: '',
            body: ''
          },
          keys: {
            subject: 'TemplateMailForgotPasswordSubject',
            body: 'TemplateMailForgotPasswordBody'
          }
        }
      ]
    },
    isSuperAdmin: function () {
      return this.$store.getters['session/isSuperAdmin']
    },
    isAdministrator: function () {
      return this.$store.getters['session/hasRole']('ADMIN')
    },
    showGlobalConfiguration: function () {
      return this.isSuperAdmin
    },
    showMailConfiguration: function () {
      return this.isSuperAdmin || this.isAdministrator
    },
    showMailTemplate: function () {
      return this.isSuperAdmin || this.isAdministrator
    }
  },
  methods: {
    loadGlobalConfiguration () {
      // console.log('Load global configuration')
    },
    loadMailConfiguration () {
      // console.log('Loading mail configuration')
      axios.get('/backend/ui/configuration/mail')
        .then(response => {
          this.mailConfiguration = response.data
        })
    },
    saveMailConfiguration () {
      console.log('Save mail configuration')
      axios.post('/backend/ui/configuration/mail', this.mailConfiguration)
        .then(response => {
          this.loadMailConfiguration()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })
    },
    loadMailTemplate () {
      this.currentTemplate = null
      for (let t of this.mailTemplates) {
        if (t.key === this.currentTemplateKey) {
          this.currentTemplate = t
          break
        }
      }
      if (!this.currentTemplate) {
        return
      }

      axios.get('/backend/ui/configuration/' + this.currentTemplate.keys.subject)
        .then(response => {
          this.currentTemplate.values.subject = response.data.value
        })
      axios.get('/backend/ui/configuration/' + this.currentTemplate.keys.body)
        .then(response => {
          this.currentTemplate.values.body = response.data.value
        })
    },
    saveMailTemplate () {
      axios.post('/backend/ui/configuration', querystring.stringify({ key: this.currentTemplate.keys.subject, value: this.currentTemplate.values.subject }))
      axios.post('/backend/ui/configuration', querystring.stringify({ key: this.currentTemplate.keys.body, value: this.currentTemplate.values.body }))
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Configuration.vue